import { render, staticRenderFns } from "./BookPreview.vue?vue&type=template&id=fc5cd272&scoped=true&"
import script from "./BookPreview.vue?vue&type=script&lang=js&"
export * from "./BookPreview.vue?vue&type=script&lang=js&"
import style0 from "./BookPreview.vue?vue&type=style&index=0&id=fc5cd272&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc5cd272",
  null
  
)

export default component.exports